module.exports = __webpack_public_path__ + "img/coat-of-arms.63c268de.png";